<template>
  <div class="settings-form">
    <div class="form-group">
      <label class="form-label">Social Networks</label>
      <div class="social-list">
        <div 
          v-for="(network, index) in localSettings.networks" 
          :key="index"
          class="social-item"
        >
          <select 
            v-model="network.name"
            class="form-select"
            @change="emitUpdate"
          >
            <option value="facebook">Facebook</option>
            <option value="twitter">Twitter</option>
            <option value="instagram">Instagram</option>
            <option value="linkedin">LinkedIn</option>
            <option value="youtube">YouTube</option>
          </select>
          <input 
            v-model="network.url"
            type="url"
            class="form-input"
            placeholder="https://..."
            @input="emitUpdate"
          />
          <button 
            class="btn btn-sm btn-danger"
            @click="removeNetwork(index)"
            :disabled="localSettings.networks.length === 1"
          >
            🗑️
          </button>
        </div>
      </div>
      <button class="btn btn-outline btn-sm mt-2" @click="addNetwork">
        ➕ Add Network
      </button>
    </div>

    <div class="form-group">
      <label class="form-label">Style</label>
      <select v-model="localSettings.style" class="form-select" @change="emitUpdate">
        <option value="default">Default</option>
        <option value="circle">Circle</option>
        <option value="square">Square</option>
      </select>
    </div>

    <div class="form-group">
      <label class="form-label">CSS Class</label>
      <input 
        v-model="localSettings.class"
        type="text"
        class="form-input"
        placeholder="custom-class"
        @input="emitUpdate"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  settings: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update']);

const localSettings = ref({ 
  networks: [{ name: 'facebook', url: 'https://facebook.com' }],
  style: 'default',
  class: '',
  ...props.settings 
});

watch(() => props.settings, (newSettings) => {
  localSettings.value = { ...newSettings };
}, { deep: true });

function addNetwork() {
  if (!localSettings.value.networks) localSettings.value.networks = [];
  localSettings.value.networks.push({ name: 'facebook', url: 'https://facebook.com' });
  emitUpdate();
}

function removeNetwork(index) {
  if (localSettings.value.networks.length > 1) {
    localSettings.value.networks.splice(index, 1);
    emitUpdate();
  }
}

function emitUpdate() {
  emit('update', localSettings.value);
}
</script>

<style scoped>
.social-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
}

.social-item {
  display: flex;
  gap: 8px;
  align-items: center;
}

.social-item select {
  flex: 0 0 140px;
}

.social-item input {
  flex: 1;
}
</style>

